(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["zinko-grid-view"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('zinko-grid-view')) {
 customElements.define('zinko-grid-view', class extends HTMLElement {
  connectedCallback() {
   this.screen = matchMedia('(min-width:990px)');
   this.update = value => {
    const allowed = this.screen.matches ? ['2','3','4','6'] : ['1','2','3'];
    if (!allowed.includes(value)) value = this.screen.matches ? '4' : '2';
    document.documentElement.dataset.zinkoGrid = value;
    this.querySelectorAll('button').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.columns === value)));
   };
   this.restore = () => {
    let value;
    try { value = sessionStorage.getItem(this.screen.matches ? 'zinko-grid-desktop' : 'zinko-grid-mobile'); } catch (error) {}
    this.update(value);
   };
   this.restore();
   this.screen.addEventListener('change', this.restore);
   this.onclick = event => {
    const button = event.target.closest('button[data-columns]');
    if (!button) return;
    this.update(button.dataset.columns);
    try { sessionStorage.setItem(this.screen.matches ? 'zinko-grid-desktop' : 'zinko-grid-mobile', button.dataset.columns); } catch (error) {}
   };
  }
  disconnectedCallback() {
   this.screen.removeEventListener('change', this.restore);
  }
 });
}
if (!window.zinkoCollectionReturn) {
 window.zinkoCollectionReturn = true;
 const positionKey = () => 'zinko-collection-position:' + location.pathname + location.search;
 const savePosition = () => {
  const grid = document.querySelector('#product-grid');
  if (!grid) return;
  const cards = Array.from(grid.children);
  const card = cards.find(item => item.getBoundingClientRect().bottom > 0);
  const link = card && card.querySelector('a[href*="/products/"]');
  try {
   sessionStorage.setItem(positionKey(), JSON.stringify({
    y: window.scrollY,
    href: link && link.getAttribute('href'),
    top: card && card.getBoundingClientRect().top
   }));
  } catch (error) {}
 };
 document.addEventListener('click', event => {
  const link = event.target.closest('a[href*="/products/"]');
  if (link && link.closest('#product-grid')) savePosition();
 }, true);
 window.addEventListener('pagehide', savePosition);
 window.addEventListener('pageshow', event => {
  const navigation = performance.getEntriesByType('navigation')[0];
  if (!event.persisted && (!navigation || navigation.type !== 'back_forward')) return;
  let saved;
  try { saved = JSON.parse(sessionStorage.getItem(positionKey())); } catch (error) {}
  if (!saved || !Number.isFinite(saved.y)) return;
  let cancelled = false;
  const cancel = () => { cancelled = true; };
  window.addEventListener('wheel', cancel, {once:true, passive:true});
  window.addEventListener('touchstart', cancel, {once:true, passive:true});
  window.addEventListener('keydown', cancel, {once:true});
  const restore = () => {
   if (cancelled) return;
   const grid = document.querySelector('#product-grid');
   const link = grid && Array.from(grid.querySelectorAll('a[href*="/products/"]')).find(item => item.getAttribute('href') === saved.href);
   const card = link && link.closest('.grid__item');
   const y = card && Number.isFinite(saved.top) ? window.scrollY + card.getBoundingClientRect().top - saved.top : saved.y;
   window.scrollTo({top:y,behavior:'instant'});
  };
  requestAnimationFrame(() => requestAnimationFrame(restore));
  const observer = new ResizeObserver(restore);
  const grid = document.querySelector('#product-grid');
  if (grid) observer.observe(grid);
  setTimeout(() => {
   observer.disconnect();
   window.removeEventListener('wheel', cancel);
   window.removeEventListener('touchstart', cancel);
   window.removeEventListener('keydown', cancel);
  }, 1500);
 });
}
  } catch(e) { console.error(e); }
})();

})();
